import React from "react"

import "./form.css"
import setCookie from "../../utils/setCookie"

export default function LoginForm({onContinue}) {
	// state variables
	const [email, setEmail] = React.useState("")
	const [disabled, setDisabled] = React.useState(false)

	// checks if user is authenticated and opens Pinwheel SDK
	const handleContinue = async () => {
		try {
			setDisabled(true)

			// check if email is valid
			if (!email || email === "" || !email.includes("@")) {
				alert("Please enter a valid email address")
				return
			}

            if (onContinue) onContinue(email);

            setCookie("authentication_token", email);
		} catch (err) {
			console.log(err)
		} finally {
			setDisabled(false)
		}
	}

	return (
		<div className="login-form">
			<div>
				<div className="label">
					<label className="label-text">Please enter your email address</label>
					<p className="required">*</p>
				</div>
				<input
					className="input"
					placeholder="Email address..."
					value={email}
					onChange={(e) => setEmail(e.target.value)}
				/>
			</div>
			<button
				disabled={disabled}
				onClick={() => handleContinue()}
				className="button"
			>
				Continue
			</button>
		</div>
	)
}
